import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import Tooltip from '@material-ui/core/Tooltip';
import { AppStyles } from '../styles/AppTheme';
import { Controller } from '../common/Controller';
import { Helper } from '../common/helpers/Helper';
import { AppConfig } from '../AppConfig'
import moment from 'moment';
import { CommonStyles } from '../styles/Styles';

export class AppHelper {
  static buttonEdit(caller, current) {
    return (
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForEdit(current)}>edit</i>
        </span>
      </Tooltip>
    )
  }

  static buttonDelete(caller, current) {
    return (
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
  }

  static populateOptions(formDefinition, apiResult, key) {
    const options = []
    for (const d of apiResult.items) {
      options.push({
        key: d.id,
        text: d.title
      })
    }
    for (const field of formDefinition.steps[0].fields) {
      if (field.key === key) {
        field.options = options
      }
    }
  }

  static shouldMoveNextProfileStep(currentStep) {
    const appUser = Controller.get().userMgr().getAppUser()

    if (appUser.state === 'READY') return true

    if (appUser.state === 'BASIC_INFO_DONE' &&
      (currentStep === 'BASIC_INFO' ||
        currentStep === 'CONTACT_INFO')) {
      return true
    }

    if (appUser.state === 'CONTACT_INFO_DONE' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO' ||
        currentStep === 'CONSENT_INFO')) {
      return true
    }

    if (appUser.state === 'CONSENT_DONE_PARENT_PENDING' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO' ||
        currentStep === 'CONSENT_INFO')) {
      return true
    }

    if (appUser.state === 'CONSENT_DONE' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO' ||
        currentStep === 'CONSENT_INFO' ||
        currentStep === 'CUSTOMIZE_INFO')) {
      return true
    }
    return false
  }

  static isProfileSectionComplete(currentStep) {
    const appUser = Controller.get().userMgr().getAppUser()

    if (appUser.state === 'READY') return true

    if (appUser.state === 'BASIC_INFO_DONE' &&
      (currentStep === 'BASIC_INFO')) {
      return true
    }

    if (appUser.state === 'CONTACT_INFO_DONE' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO')) {
      return true
    }

    if (appUser.state === 'CONSENT_DONE' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO' ||
        currentStep === 'CONSENT_INFO')) {
      return true
    }

    if (appUser.state === 'CONSENT_DONE_PARENT_PENDING' &&
      (currentStep === 'CONTACT_INFO' ||
        currentStep === 'BASIC_INFO' ||
        currentStep === 'CONSENT_INFO')) {
      return true
    }

    return false
  }

  static isProfileCompleteAndpreReqCheckPassed = () => {
    if (Controller.get().userMgr().isProductSU()) {
      return true
    }
    const appUser = Controller.get().userMgr().getAppUser()
    if (!appUser.dob) {
      return false
    }
    const age = Helper.calculateAge(moment(appUser.dob, 'DD-MMM-YYYY').valueOf())
    if (appUser.addressCountryCode === 'OTHER' || age < AppConfig.AGE_LOWER_LIMIT) {
      return false
    }
    if (appUser.state !== 'READY') {
      return false
    }
    return true
  }

  static getOtherValuePrefix() {
    return 'otherValue-'
  }

  static createReferralLink() {
    const appUser = Controller.get().userMgr().getAppUser()
    return AppConfig.WEB_URL + '?referral=' + appUser.referralCode
  }

  static componentDecorator = (href, text, key, style) => (
    <a
      href={href}
      key={key}
      target='_blank'
      className={css(style, CommonStyles.colouredLink)}
    >
      {text}
    </a>
  )

  static getProfileActiveIndex() {//TODO: move indexes to enums
    const appUser = Controller.get().userMgr().getAppUser()
    let age = null
    if(appUser.dob) {
      const dob = moment(appUser.dob, 'DD-MMM-YYYY').valueOf()
      age = Helper.calculateAge(dob)
    }
    if(appUser.state === 'INIT') {
      return 0
    } else if(appUser.state === 'BASIC_INFO_DONE') {
      return 1
    } else if(appUser.state === 'CONTACT_INFO_DONE') {
      return 2
    } else if(appUser.state === 'CONSENT_DONE_PARENT_PENDING') {
      return 2
    } else if(appUser.state === 'CONSENT_DONE') {
      return 2
      // return 3
    } else if(appUser.state !== 'READY') {
      return 2
      // return 3
    } else {
      return 0
    }
  }

  static calculateAgeBasedonUserCreatedTs(appUser) {
    const ts = moment(appUser.dob, 'DD-MMM-YYYY').valueOf()
    const birthDate = moment(ts)
    const yB = Number(moment(birthDate).format('YYYY'))
    const mB = Number(moment(birthDate).format('M'))
    const dB = Number(moment(birthDate).format('D'))
    const tsB = Number(moment(birthDate).valueOf())

    const today = appUser.createdTs
    const yT = Number(moment(today).format('YYYY'))
    const mT = Number(moment(today).format('M'))
    const dT = Number(moment(today).format('D'))
    const tsT = Number(moment(today).valueOf())

    let age = yT - yB

    if(age !== AppConfig.AGE_LOWER_LIMIT && age !== AppConfig.AGE_UPPER_LIMIT) {
      return age
    }

    if(age === AppConfig.AGE_LOWER_LIMIT) {
      const m = mT - mB
      if(m < 0) {
        age = age - 1
        return age;
      }
      if (m === 0) {
        if (dT < dB) {
          age = age - 1
          return age
        } else {
          return age
        }
      }
      if(m > 0) {
        return age
      }
    }

    if(age === AppConfig.AGE_UPPER_LIMIT) {
      const m = mT - mB
      if(m < 0) {
        age = age - 1
        return age;
      }
      if (m === 0) {
        if (dT < dB) {
          age = age - 1
          return age
        } else {
          return age
        }
      }
      if(m > 0) {
        return age
      }
    }
  }

  static arrToCsv(items) {
    let csv = ''
    if(!items) return csv
    for(const item of items) {
      if(csv.length === 0) {
        csv = item
      } else {
        csv = csv + ', ' + item
      }
    }
    return csv
  }

  static arrToCsvWithNewline(items) {
    let csv = ''
    if(!items) return csv
    for(const item of items) {
      if(csv.length === 0) {
        csv = item
      } else {
        csv = csv + ',\n' + item
      }
    }
    return csv
  }

  static formatAddress(current) {
    if(!current) return ''
    let addr = ''
    if(current.addressL1) {
      addr = addr + current.addressL1 + ','
    }
    if(current.addressCity) {
      addr = addr + current.addressCity + ','
    }
    if(current.addressState) {
      addr = addr + current.addressState + ','
    }
    if(current.addressZip) {
      addr = addr + current.addressZip + ','
    }
    if(current.addressCountryCode) {
      addr = addr + current.addressCountryCode
    }
    return addr
  }

  static getCopyrightString() {
    return <p className={css(CommonStyles.copyright)}>© Copyright NEXTGEN JANE® {moment().year()}</p>
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js